import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

/**
 * Componente de loading spinner inline para uso em botões e elementos pequenos.
 * Usa o SVG padronizado do sistema.
 *
 * Uso:
 * <app-loading-spinner></app-loading-spinner>
 * <app-loading-spinner size="sm"></app-loading-spinner>
 * <app-loading-spinner size="md" class="mr-2"></app-loading-spinner>
 */
@Component({
  selector: 'app-loading-spinner',
  standalone: true,
  imports: [CommonModule],
  template: `
    <img
      src="assets/img/Loading.svg"
      alt="Carregando..."
      [ngClass]="sizeClass"
      class="inline-block"
    />
  `,
  styles: [
    `:host
  display: inline-flex
  align-items: center
  justify-content: center`
  ]
})
export class LoadingSpinnerComponent {
  /**
   * Tamanho do spinner
   * - 'xs': 16px (h-4 w-4)
   * - 'sm': 20px (h-5 w-5)
   * - 'md': 32px (h-8 w-8)
   * - 'lg': 48px (h-12 w-12)
   */
  @Input() size: 'xs' | 'sm' | 'md' | 'lg' = 'sm';

  get sizeClass(): string {
    const sizes = {
      'xs': 'w-4 h-4',
      'sm': 'w-5 h-5',
      'md': 'w-8 h-8',
      'lg': 'w-12 h-12'
    };
    return sizes[this.size];
  }
}
